.fondo {
  min-height: 100dvh;
  display: grid;
  place-items: center;
  padding: var(--s-6);
  background: var(--surface-page);
}
.tarjeta {
  width: 100%;
  max-width: 400px;
  display: grid;
  gap: var(--s-8);
}
.marca {
  display: grid;
  gap: var(--s-6);
}
.formulario {
  display: grid;
  gap: var(--s-5);
}
